// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fv-0";
export var fulfillmentPanelBody = "_fv-1";